import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api"; // Import API service
import "../AddBlog/index.css";

export default function EditDownload() {
  const { id } = useParams(); // Get ID from URL
  const [name, setName] = useState("");
  const [version, setVersion] = useState("");
  const [description, setDescription] = useState("");
  const [exeFile, setExeFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [currentExeFile, setCurrentExeFile] = useState("");
  const [currentImage, setCurrentImage] = useState("");
  const [currentVersion, setCurrentVersion] = useState("");
  const [currentDescription, setCurrentDescription] = useState("");
  const alert = useSwal();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Fetch Existing Download Details
  useEffect(() => {
    async function fetchDownloadDetails() {
      try {
        const response = await api.post(`/GetDownLoad/${id}`); // Fetch details
        if (response.status === 200) {
          setName(response.data.name);
          setVersion(response.data.version || "");
          setDescription(response.data.description || "");
          setCurrentVersion(response.data.version || "");
          setCurrentDescription(response.data.description || "");
          setCurrentExeFile(response.data.exeFile || response.data.exe_file || response.data.exeFilename || "");
          setCurrentImage(
            response.data.image ||
            response.data.imageFile ||
            response.data.image_file ||
            response.data.imageFilename ||
            ""
          );
        }
      } catch (error) {
        console.error("Error fetching download:", error);
        alert("error", "Failed to load download details.");
      }
    }
    fetchDownloadDetails();
  }, [id, alert]);

  // Handle EXE File Selection
  const handleExeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.name.toLowerCase().endsWith(".exe") && file.type !== "application/octet-stream") {
        alert("error", "Please select a valid EXE file.");
        return;
      }
      setExeFile(file);
    }
  };

  // Handle Image File Selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/svg+xml", "image/webp"];
    if (file) {
      if (!validTypes.includes(file.type)) {
        alert("error", "Please select a valid image file (SVG, JPG, PNG, WEBP).");
        return;
      }
      setImageFile(file);
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name) {
      alert("error", "Please enter a download name.");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("version", version);
    formData.append("description", description);
    if (exeFile) {
      formData.append("exeFile", exeFile);
      formData.append("exe", exeFile);
    }
    if (imageFile) {
      formData.append("imageFile", imageFile);
      formData.append("image", imageFile);
    }

    try {
      setLoading(true);
      const response = await api.post(`/editDownLoad/${id}`, formData);

      if (response.status === 200) {
        alert("success", "Download updated successfully!");

        navigate("/exe-uploads");
      }
    } catch (error) {
      console.error("Error updating file:", error);
      alert("error", "Failed to update download.");
    }finally {
      setLoading(false);
    }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit Exe Files Details"  backTo="/exe-uploads" />
      <div className="pageLeftspace">
        {/* Form Section */}
        <div className="d-flex justify-content-start col-xl-6 col-12">
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
          <div className="grid-container user">
            {/* Product Name Input */}
            <div className="input-container">
              <input
                type="text"
                id="name"
                placeholder="Enter EXE Product Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <span className="underline"></span>
            </div>

            {/* Version Input */}
            <div className="input-container">
              <input
                type="text"
                id="version"
                placeholder="Enter File Version"
                value={version}
                onChange={(e) => setVersion(e.target.value)}
              />
              <span className="underline"></span>
              {currentVersion && (
                <p className="file-name">Current Version: {currentVersion}</p>
              )}
            </div>

            {/* Description Input */}
            <div className="input-container description-container">
              <textarea
                id="description"
                placeholder="Enter File Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <span className="underline"></span>
              {currentDescription && (
                <p className="file-name">Current Description: {currentDescription}</p>
              )}
            </div>

            {/* EXE File Upload */}
            <div className="input-container file-input-container">
              <label htmlFor="exeUpload" className="file-label">Upload replacement EXE file</label>
              <input
                type="file"
                id="exeUpload"
                onChange={handleExeChange}
                className="file-input"
                accept=".exe"
              />
              <span className="underline"></span>
              {exeFile ? (
                <p className="file-name">EXE: {exeFile.name}</p>
              ) : (
                currentExeFile && <p className="file-name">Current EXE: {currentExeFile}</p>
              )}
            </div>

            {/* Image File Upload */}
            <div className="input-container file-input-container">
              <label htmlFor="imageUpload" className="file-label">Upload replacement image</label>
              <input
                type="file"
                id="imageUpload"
                onChange={handleImageChange}
                className="file-input"
                accept=".svg,.jpg,.jpeg,.png,.webp"
              />
              <span className="underline"></span>
              {imageFile ? (
                <p className="file-name">Image: {imageFile.name}</p>
              ) : (
                currentImage && <p className="file-name">Current Image: {currentImage}</p>
              )}
            </div>

            <button className="btn btn-purpal" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </div>

          {/* Submit Button */}

        </form>
        </div>
      </div>
    </section>
  );
}
